// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"258b012d","667":"8859cc3d","977":"37d9e8f3"}[chunkId] + ".chunk.js";
};